import { useState, useEffect } from "react";

const isWindowTabletWidth = () => window.document.documentElement.clientWidth === 768;

const useTabletChecker = () => {
  const [isTablet, setIsTablet] = useState(isWindowTabletWidth);
  useEffect(() => {
    const handleResize = () => setIsTablet(isWindowTabletWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return isTablet;
};

export default useTabletChecker;